export default function HeroSection() {
  return (
    <header className="relative w-full min-h-screen flex flex-col bg-background-50">
      <div className="flex-1 flex flex-col">
        <div className="flex-1 flex flex-col lg:flex-row items-center px-10 md:px-16 pt-32 pb-12 lg:pb-16 w-full max-w-[1440px] mx-auto gap-10 lg:gap-0">
          <div className="w-full lg:w-1/2 flex flex-col justify-center">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-foreground-950 leading-[0.9] tracking-tight">
              (Rm Software)
              <br />
              <span className="text-foreground-800">Modern Systems</span>
            </h1>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col justify-center lg:pl-10">
            <p className="text-lg md:text-xl text-foreground-600 leading-relaxed max-w-lg">
              A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.
            </p>
            <p className="mt-6 text-base text-foreground-500 font-light">
              Building scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
            </p>
          </div>
        </div>

        <div className="w-full px-10 md:px-16 pb-20 max-w-[1440px] mx-auto">
          <div className="w-full h-[400px] md:h-[450px] rounded-3xl overflow-hidden relative">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20composition%20of%20layered%20geometric%20forms%20with%20subtle%20warm%20amber%20and%20cream%20gradients%2C%20soft%20overlapping%20translucent%20shapes%20creating%20depth%2C%20minimalist%20contemporary%20aesthetic%2C%20no%20text%2C%20no%20human%20figures%2C%20no%20identifiable%20objects%2C%20clean%20ethereal%20atmosphere%20with%20gentle%20light%20diffusion%2C%20high%20resolution%20editorial%20quality%2C%20smooth%20curves%20and%20rectilinear%20planes%20intersecting&width=1600&height=450&seq=hero-abstract-01&orientation=landscape"
              alt="Abstract geometric composition representing modern software architecture"
              title="Rm Software - Modern engineering design aesthetic"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </header>
  );
}